module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h3', [_vm._v(_vm._s(_vm.multiLanguage.relationshipListReport))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "panel",
    attrs: {
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(255, 255, 255, 0.5)"
    }
  }, [_c('itable', {
    attrs: {
      "thData": _vm.thTitle,
      "trData": _vm.trData,
      "page": _vm.page,
      "multiLanguage": _vm.multiLanguage,
      "seekDropdown": _vm.seekDropdown,
      "selPage": _vm.selPage,
      "filterData": _vm.filterData
    },
    on: {
      "tableChange": _vm.tableAjax,
      "seek": _vm.tableAjax,
      "downLoadExcelFn": _vm.excelDown,
      "filterFn": _vm.filterFn
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea5fda40","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CommissionSetting2/Sale/SaleReport/relationshipListReport.vue
// module id = 1145
// module chunks = 1